
export function serviceHost() {
  if (process.env.REACT_APP_FINTECHONE_SERVICE_HOST) {
    return process.env.REACT_APP_FINTECHONE_SERVICE_HOST;
  }
  return 'https://fintechone-service.validdata.de'
}

export function servicenUrl() {
  return  serviceHost() + '/portalApi/v1.0/';
}

export function serviceInspectionUrl() {
  return  servicenUrl() + 'inspection/';
}

export function serviceUrlHuesgesPost() {
  return  serviceInspectionUrl() + 'huesges/';
}

export function serviceUrlTuevPost() {
  return  serviceInspectionUrl() + 'tuev/';
}

export function serviceDisclosureUrl() {
  return  servicenUrl() + 'disclosure/';
}

export const callbackServiceUrl = 'http://s735415353.online.de/webseite/#kontakt';
export const supportChatUrl = 'https://support1.imsupporting.com/welcome3/index.php?siteid=3820180514302';



// WEBPACK FOOTER //
// ./src/shared/api/urls.tsx